<app-guest-auth-main-layout>
  <ng-template>


    <div class="grid grid-cols-3 gap-3 mb-4">
      <div (click)="setRegistrationType('citizen')"
           class="p-2 cursor-pointer flex items-center gap-2 justify-center text-center border-2 rounded-md border-primary-500 "
           [ngClass]="{' text-gray-600': registerAs !=='citizen', 'bg-primary-500 text-secondary-500': registerAs ==='citizen'}">

        <mat-icon class="text-secondary-500" svgIcon="group"></mat-icon>
        <span>  {{"Mwananchi"|concat|translate}}     </span>
      </div>

      <div (click)="setRegistrationType('foreigner')"
           class="p-2 cursor-pointer flex items-center gap-2 justify-center text-center border-2 rounded-md border-primary-500 "
           [ngClass]="{' text-gray-600': registerAs !=='foreigner', 'bg-primary-500 text-secondary-500': registerAs ==='foreigner'}">

        <mat-icon class="text-secondary-500" svgIcon="foreigner"></mat-icon>
        <span> {{"Foreigner"|concat|translate}} </span>
      </div>

      <div (click)="setRegistrationType('company')"
           class="p-2 cursor-pointer flex items-center gap-2 justify-center text-center border-2 rounded-md border-primary-500 "
           [ngClass]="{' text-gray-600': registerAs !=='company', 'bg-primary-500 text-secondary-500': registerAs ==='company'}">

        <mat-icon class="text-secondary-500">work_outline</mat-icon>
        <span> {{"Kampuni"|concat|translate}} </span>
      </div>


    </div>

    @if (registerAs === 'citizen') {
      <div class="w-full  px-1 py-3">
        <app-citizen-registration></app-citizen-registration>
      </div>
    } @else if (registerAs === 'foreigner') {
      <div class="w-full  px-1 py-3">
        <app-foreigner-registration></app-foreigner-registration>
      </div>
    } @else if (registerAs === 'company') {
      <div class="w-full  px-1 py-3">
        <app-company-registration></app-company-registration>
      </div>
    }
  </ng-template>

</app-guest-auth-main-layout>
